import { observer } from 'mobx-react';
import React from "react";
import { Facebook, Instagram, Link, Linkedin, Twitter, Youtube, ArrowUpRight } from "react-feather";
import { Button, Col, Form, FormGroup, Input, Label, Row, InputGroup, InputGroupAddon } from "reactstrap";
import "../../../assets/scss/pages/users.scss";
import ICustomer from "../../../types/ICustomer";
import InputText from '../../common/InputText';

interface ICustomerSocialTabProps {
  customer: ICustomer,
  onChangeText: Function,
  onSave: Function
}

interface ICustomerSocialTabState {
}

@observer
class CustomerSocialTab extends React.Component<ICustomerSocialTabProps, ICustomerSocialTabState> {

  render() {
    let { customer, onChangeText, onSave } = this.props;
    return (
      <React.Fragment>
        <h5 className="mb-1">
          <Link size={16} />
          <span className="align-middle ml-50">Social Links</span>
        </h5>
        <Row>
          <Col md="4" sm="12">
            <InputText
              type="text"
              id="facebook"
              name="facebook"
              onChange={(e) => onChangeText("social.facebook", e.target.value)}
              label=""
              value={customer.social.facebook}
              placeholder="https://facebook.com/"
              controlIcon={<Facebook size={20}/>}
            />
            <InputText
              type="text"
              id="twitter"
              name="twitter"
              onChange={(e) => onChangeText("social.twitter", e.target.value)}
              label=""
              value={customer.social.twitter}
              placeholder="https://twitter.com/"
              controlIcon={<Twitter size={20}/>}
            />
            </Col>
          <Col md="4" sm="12">
            <InputText
              type="text"
              id="linkedin"
              name="linkedin"
              onChange={(e) => onChangeText("social.linkedin", e.target.value)}
              label=""
              value={customer.social.linkedin}
              placeholder="https://linkedin.com/"
              controlIcon={<Linkedin size={20}/>}
            />
          <InputText
              type="text"
              id="instagram"
              name="instagram"
              onChange={(e) => onChangeText("social.instagram", e.target.value)}
              label=""
              value={customer.social.instagram}
              placeholder="https://instagram.com/"
              controlIcon={<Instagram size={20}/>}
            />
            </Col>
          <Col md="4" sm="12">
            <InputText
              type="text"
              id="youtube"
              name="youtube"
              onChange={(e) => onChangeText("social.youtube", e.target.value)}
              label=""
              value={customer.social.youtube}
              placeholder="https://youtube.com/"
              controlIcon={<Youtube size={20}/>}
            />
          </Col>
        </Row>
      </React.Fragment>
    )
  }
}
export default CustomerSocialTab;


{/* <FormGroup className="position-relative has-icon-left has-icon-right">
  <Input
    id="facebook"
    value={customer.social.facebook}
    onChange={(e) => onChangeText("social.facebook", e.target.value)}
    placeholder="https://www.facebook.com/" />
  <div className="form-control-position bg-gray pr-7">
    <Facebook size={16} />
  </div>
  <div className="form-control-position">
    <Facebook size={22} />
  </div>
</FormGroup> */}